{
  "title": "Water Breathing",
  "source": "Player's Handbook",
  "levelAndSchool": "3rd-level transmutation (ritual)",
  "level": 3,
  "castingTime": "1 action",
  "range": "30 feet",
  "components": "V, S, M (a short reed or piece of straw)",
  "duration": "24 hours",
  "description": [
    "This spell grants up to ten willing creatures you can see within range the ability to breathe underwater until the spell ends. Affected creatures also retain their normal mode of respiration."
  ],
  "spellLists": ["artificer", "druid", "ranger", "sorcerer", "wizard"]
}
